export default __webpack_public_path__ + "static/media/about-slide-2.d6c561b3.svg";